import { render, staticRenderFns } from "./TSZ_Resetear.vue?vue&type=template&id=442c53d9&scoped=true&"
import script from "./TSZ_Resetear.vue?vue&type=script&lang=js&"
export * from "./TSZ_Resetear.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_Resetear.vue?vue&type=style&index=0&id=442c53d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442c53d9",
  null
  
)

export default component.exports